import { useLanguageContext } from './LanguageContext';
import { getTranslations, type TranslationKey } from './translations';

export function useLanguage() {
  const { language, setLanguage, toggleLanguage } = useLanguageContext();
  
  // Translation function
  const t = (key: TranslationKey, replacements?: Record<string, string | number>): string => {
    const translations = getTranslations(language);
    let value = translations[key];
    
    if (!value) {
      console.warn(`Missing translation: ${key} (${language})`);
      // Fallback to German
      const deFallback = getTranslations('de');
      value = deFallback[key] || key;
    }
    
    // Handle replacements like {current}, {total}
    if (replacements) {
      Object.keys(replacements).forEach((placeholder) => {
        value = value.replace(`{${placeholder}}`, String(replacements[placeholder]));
      });
    }
    
    return value;
  };
  
  return {
    language,
    setLanguage,
    toggleLanguage,
    t,
  };
}
